module.exports = __webpack_public_path__ + "static/media/ITCAvantGardeStd-Demi.965e2adf.svg";